export default __webpack_public_path__ + "static/media/404.3e2b3139.gif";